const brandColor = {
	white: '#ffffff',
	blue: '#2c80df',
	blueSky: '#12a6df',
	blueIndigo: '#8379e5',
	blueIndigoLight: '#cecaf5',
	red: '#f15753',
	redLight: '#eb736f',
	redDark: '#cf302b',
	lightPink: '#ffcccc',
	blueCyan: '#00bfa6',
	blueGrey: '#6793a9',
	green: '#1ABC9C', //"#3ca36d",
	greenLight: '#2ed47e1a',
	greenLighter: '#edf7f4',
	green50: '#2ed47e82',
	greenInfo: '#3fa99f',
	greenInfoLight: '#76c7c0',
	yellow: '#ffc107',
	yellowOrange: '#ffb264',
	yellowOrangeLight: '#f5cba0',
	gray: '#7a7a7a',
	bodyGray: '#4d4d4d',
	lightGray: '#a3a3a3',
	lighterGray: '#dbdbdb',
	lighterPlusGray: '#f3f3f3',
	darkGray: '#343a40',
	systemDarkBlue: '#02284c',
};

export default brandColor;
